import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Tabs, Tab } from "react-bootstrap";
import { fetchStripeAccount, checkTicketDaschoardStatus } from "TicketAction";
import { fetchSettings } from "TicketAction";
import { DEVELOPMENT_TYPE } from "Constants";
import PGStripe from "PGStripe";
import PGPayfast from "PGPayfast";
import LocaleStrings from "Languages";

class PaymentGatway extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedTab: 1 };
  }

  componentDidMount() {
    this.props.fetchStripeAccount(this.props.session);
    this.props.fetchSettings(this.props.session);
    this.props.checkTicketDaschoardStatus(this.props.session);
  }

  handleSelect = (key) => {
    this.setState({ selectedTab: key });
  };

  render() {
    let { selectedTab } = this.state;
    let { deviceSize } = this.props;

    return (
      <div
        className="panel-body scrollable-content"
        // style={{
        //   height: deviceSize.height - 70,
        // }}
      >
        <Tabs
          id="branding-tab"
          activeKey={selectedTab}
          onSelect={this.handleSelect}
        >
          <Tab eventKey={1} title={LocaleStrings.tickets_payout_tab1}>
            {selectedTab == 1 ? (
              <PGStripe
                callfrom={this.props.callfrom ? this.props.callfrom : "payout"}
              />
            ) : null}
          </Tab>
          {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <Tab eventKey={2} title={LocaleStrings.tickets_payout_tab2}>
              {selectedTab == 2 ? (
                <PGPayfast
                  callfrom={
                    this.props.callfrom ? this.props.callfrom : "payout"
                  }
                />
              ) : null}
            </Tab>
          )}
        </Tabs>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  fetchStripeAccount,
  fetchSettings,
  checkTicketDaschoardStatus,
})(PaymentGatway);
